<template lang="pug">
#app
    template(v-if="!this.$route.path.includes('login')")
      header-content(@hasTopBar="handleHeigth")
      div.ods-flex
        nav-content
        ods-main
          ods-scrollbar(:wrapClass="wrapClass")
            router-view
            footer
    template(v-else)
      router-view
</template>

<script>
import HeaderContent from '@/components/header/HeaderContent'
import NavContent from '@/components/nav/NavContent'

export default {
  name: 'App',
  components: {
    HeaderContent,
    NavContent
  },

  data () {
    return {
      wrapClass: ''
    }
  },

  methods: {
    handleHeigth (val) {
      this.wrapClass = val
        ? 'ods-scrollbar--main-content has-top-bar'
        : 'ods-scrollbar--main-content'
    }
  }
}
</script>

<style lang="scss">
// You can change this two options to configure your main container
:root {
  --main-padding: 0;
  --main-background: var(--color-bg-terciary);
}

// Calculating windows heights. Do not manipulate!
html,
body {
  .ods-scrollbar--main-content {
    height: calc(100vh - #{$--header-height});
    padding: var(--main-padding);
    background: var(--main-background);
    &.has-top-bar {
      height: calc(100vh - #{$--header-height} - #{$--header-topbar});
    }
  }
}
// End calculating windows heights.

// Your global styles goes from here ↓↓↓↓
.ods-dataviz {
  height: 100%;
}

.ng-scope {
  box-sizing: border-box;

  &::-webkit-scrollbar {
    all:unset;
  }

  &::-webkit-scrollbar {
    width: 0.6em;
  }

  &::-webkit-scrollbar-track {
    background: #d9d9d9;
    border-radius: 35px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    border-radius: 35px;
  }

}

.ods-tabs__content {
  overflow: visible!important;
  height: calc(100% - 70px);
  position: inherit!important;
}

.ods-tab-pane {
  height: 100%;
}

.ods-picker-panel__body-wrapper .ods-picker-panel__sidebar {
  width: rem(114);
}

.ods-dataviz__toolbox {
  position: absolute;
  right: rem(30);
  top: rem(10);
}

.item-buttons {
  margin: 5px 8px 0px 114px!important;
}

.ods-row.is-justify-space-between.is-align-middle {
  position: initial;
}

.scroll-style {
  height: 350px!important;
}

// ODS-PIE-TABLE-CHART
.dataviz-pie-container text {
    font-size: .60vw!important;
}
</style>
